import { Box, FormControl, Skeleton } from "@mui/material";

const FreelancerOnboardingMySkillsSkeleton: React.FC = () => {
	return (
		<>
			{[...Array(2)].map(() => {
				return (
					<Box sx={{ mb: 4 }} key={`skeleton_box_parent_${crypto.randomUUID()}`}>
						{/* Title skeleton */}
						<Skeleton variant="text" width="30%" height={48} sx={{ mb: 2 }} />
						{[...Array(4)].map(() => {
							return (
								<Box sx={{ mb: 2 }} key={`skeleton_box_child_${crypto.randomUUID()}`}>
									<Skeleton variant="text" width="40%" height={24} sx={{ mb: 1 }} />
									<FormControl fullWidth size="small">
										<Skeleton
											variant="rectangular"
											height={40}
											sx={{
												width: "40%",
												borderRadius: 1,
												mb: 2
											}}
										/>
									</FormControl>
								</Box>
							);
						})}
					</Box>
				);
			})}
		</>
	);
};

export default FreelancerOnboardingMySkillsSkeleton;
